var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 124.918,
    viewBox: "0 0 150 124.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blocks",
    transform: "translate(0 -42.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(46.622 64.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(0 68.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M173.806,363.464a2.252,2.252,0,0,1-1.167-.325l-12.407-7.48a2.264,2.264,0,1,1,2.338-3.877l12.407,7.48a2.264,2.264,0,0,1-1.171,4.2Z",
    transform: "translate(-159.137 -351.456)",
    fill: "#fca62f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(38.589 68.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M293.119,363.742a2.264,2.264,0,0,1-1.072-4.259l14.464-7.757a2.263,2.263,0,1,1,2.14,3.989l-14.464,7.757A2.256,2.256,0,0,1,293.119,363.742Z",
    transform: "translate(-290.853 -351.458)",
    fill: "#fca62f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(38.588 0.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M307.709,131.339a2.252,2.252,0,0,1-1.061-.265l-14.595-7.761a2.264,2.264,0,0,1,2.125-4l14.595,7.76a2.264,2.264,0,0,1-1.064,4.263Z",
    transform: "translate(-290.852 -119.051)",
    fill: "#fca62f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M161.4,130.692a2.264,2.264,0,0,1-1.179-4.2l13.188-8.029a2.264,2.264,0,0,1,2.354,3.867l-13.188,8.028A2.25,2.25,0,0,1,161.4,130.692Z",
    transform: "translate(-159.138 -118.136)",
    fill: "#fca62f"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(6.786 87.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M25.428,208.675a2.264,2.264,0,0,1-1.179-4.2l13.717-8.351a2.264,2.264,0,1,1,2.354,3.867L26.6,208.344A2.253,2.253,0,0,1,25.428,208.675Z",
    transform: "translate(-23.162 -195.796)",
    fill: "#fca62f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M428.633,280.846a2.264,2.264,0,0,1-1.179-4.2l16.92-10.3a2.263,2.263,0,1,1,2.354,3.867l-16.92,10.3A2.253,2.253,0,0,1,428.633,280.846Z",
    transform: "translate(-308.241 -245.445)",
    fill: "#fca62f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M159.572,286.188a2.264,2.264,0,0,1-1.123-4.23l13.725-7.824a2.264,2.264,0,1,1,2.242,3.933l-13.725,7.823A2.255,2.255,0,0,1,159.572,286.188Z",
    transform: "translate(-118.006 -250.973)",
    fill: "#fca62f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M294.978,208.241a2.264,2.264,0,0,1-1.124-4.23l13.88-7.917a2.263,2.263,0,0,1,2.243,3.932l-13.88,7.917A2.253,2.253,0,0,1,294.978,208.241Z",
    transform: "translate(-213.742 -195.796)",
    fill: "#fca62f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(20.973 74.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M87.671,157.733l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-71.588 -150.218)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(35.511 74.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M135.7,150.219l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2l.045-16.467Z",
    transform: "translate(-121.211 -150.219)",
    fill: "#5169cd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(44.378 74.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M157.095,150.219l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V153.481Z",
    transform: "translate(-151.478 -150.219)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(21.018 65.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M72.5,127.083l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0L72.507,129.73a1.529,1.529,0,0,1,0-2.646Z",
    transform: "translate(-71.742 -119.374)",
    fill: "#6d81d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(20.973 74.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M87.671,157.733l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-71.588 -150.218)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(35.511 74.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M135.7,150.219l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2l.045-16.467Z",
    transform: "translate(-121.211 -150.219)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(44.378 74.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M157.095,150.219l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V153.481Z",
    transform: "translate(-151.478 -150.219)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(21.018 65.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M72.5,127.083l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0L72.507,129.73a1.529,1.529,0,0,1,0-2.646Z",
    transform: "translate(-71.742 -119.374)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(60.174 51.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M221.477,81.166l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-205.394 -73.651)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(74.712 51.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M269.5,73.652l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2l.045-16.467Z",
    transform: "translate(-255.017 -73.652)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(83.579 51.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M290.9,73.652l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V76.915Z",
    transform: "translate(-285.284 -73.652)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(60.22 42.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M206.31,50.516l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0l-13.009-7.511A1.529,1.529,0,0,1,206.31,50.516Z",
    transform: "translate(-205.549 -42.807)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(100 74.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M357.417,158.534l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-341.334 -151.019)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(114.538 74.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M405.441,151.019l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2L391,159.409Z",
    transform: "translate(-390.957 -151.019)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(123.405 74.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M426.841,151.019l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V154.281Z",
    transform: "translate(-421.224 -151.019)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(100.046 65.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M342.25,127.883l12.909-7.5a1.529,1.529,0,0,1,1.533,0L369.7,127.89a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0l-13.009-7.511A1.529,1.529,0,0,1,342.25,127.883Z",
    transform: "translate(-341.489 -120.174)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(60.488 97.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M222.549,236.989l-.027,16.7-.767.444a1.505,1.505,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-206.466 -229.474)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(75.026 97.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M270.573,229.474l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2l.045-16.467Z",
    transform: "translate(-256.089 -229.474)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(83.893 97.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M291.973,229.474l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V232.737Z",
    transform: "translate(-286.356 -229.474)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(60.533 88.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M207.381,206.338l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0l-13.009-7.511a1.529,1.529,0,0,1,0-2.646Z",
    transform: "translate(-206.621 -198.629)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(20.973 119.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M87.671,313.225l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-71.588 -305.71)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(35.511 119.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M135.7,305.711l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2l.045-16.467Z",
    transform: "translate(-121.211 -305.711)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(44.378 119.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M157.095,305.711l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V308.973Z",
    transform: "translate(-151.478 -305.711)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(21.018 110.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M72.5,282.576l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0l-13.009-7.511a1.529,1.529,0,0,1,0-2.646Z",
    transform: "translate(-71.742 -274.866)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(60.174 142.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M221.477,391.857l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-205.394 -384.342)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(74.712 142.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M269.5,384.342l-.045,15.836a1.51,1.51,0,0,1-.751,1.3L255.768,409a1.477,1.477,0,0,1-.751.2l.045-16.467Z",
    transform: "translate(-255.017 -384.342)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(83.579 142.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M290.9,384.342l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V387.6Z",
    transform: "translate(-285.284 -384.342)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(60.22 133.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M206.31,361.206l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0l-13.009-7.511A1.529,1.529,0,0,1,206.31,361.206Z",
    transform: "translate(-205.549 -353.497)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(100 120.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M357.417,314.414l-.027,16.7-.767.444a1.5,1.5,0,0,1-1.512,0l-13.023-7.518a1.509,1.509,0,0,1-.754-1.31l.045-15.827,14.535,8.39Z",
    transform: "translate(-341.334 -306.899)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(114.538 120.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M405.441,306.9l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-12.936,7.518a1.477,1.477,0,0,1-.751.2L391,315.29Z",
    transform: "translate(-390.957 -306.9)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(123.405 120.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M426.841,306.9l-.045,15.836a1.51,1.51,0,0,1-.751,1.3l-4.82,2.8V310.162Z",
    transform: "translate(-421.224 -306.9)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(100.046 111.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M342.25,283.764l12.909-7.5a1.529,1.529,0,0,1,1.533,0l13.009,7.511a1.529,1.529,0,0,1,0,2.646l-12.909,7.5a1.529,1.529,0,0,1-1.533,0l-13.009-7.511A1.529,1.529,0,0,1,342.25,283.764Z",
    transform: "translate(-341.489 -276.055)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 5.905,
    cy: 5.905,
    r: 5.905,
    transform: "translate(0 94.253)",
    fill: "#72f4c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M17.047,224.313a5.9,5.9,0,0,1-9.64,4.569,4.587,4.587,0,0,0,0-9.142,5.9,5.9,0,0,1,9.64,4.572Z",
    transform: "translate(-5.237 -124.154)",
    fill: "#27e19d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 5.905,
    cy: 5.905,
    r: 5.905,
    transform: "translate(138.19 104.56)",
    fill: "#72f4c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M489.5,259.494a5.9,5.9,0,0,1-9.32,4.814,4.894,4.894,0,0,0,0-9.628,5.9,5.9,0,0,1,9.323,4.814Z",
    transform: "translate(-339.501 -149.029)",
    fill: "#27e19d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.372dcd6f8a8e39ebcb9a747b07559d82.svg";
export { ForwardRef as ReactComponent };